import { MessageCircle } from "lucide-react";

const WhatsAppChat = () => {
  const whatsappNumber = "33756860993";
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 bg-[#25D366] hover:bg-[#20B954] text-black px-4 py-3 rounded-full shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] before:absolute before:inset-0 before:rounded-full before:bg-[#25D366] before:opacity-20 before:scale-100 before:animate-ping before:animation-duration-[3s]"
        aria-label="Discuter avec nous sur WhatsApp"
      >
        <div className="relative z-10">
          <MessageCircle className="w-6 h-6 transition-transform duration-300 group-hover:rotate-12 text-white" />
        </div>
        <span className="font-semibold text-sm whitespace-nowrap hidden md:block z-10 relative">
          Discuter avec nous
        </span>
      </a>
    </div>
  );
};

export default WhatsAppChat;